import React from 'react'
import { Box, styled } from '@mui/material'
import { get, map } from 'lodash'
import PropTypes from 'prop-types'

function DamagesMesh({ conditions, damageIcons, mesh, prefix, width }) {
  const StyledImg = styled('img')({
    width,
    height: `auto`,
  })

  return (
    <Box
      sx={{
        position: 'relative',
        margin: `0 auto`,
        width,
      }}
    >
      <StyledImg src={mesh} alt="" />
      {map(
        conditions,
        (element, key) =>
          element.coords && (
            <Box
              id={element[`${prefix}ElementId`]}
              title={element[`${prefix}ElementName`]}
              key={key}
              component="span"
              sx={{
                position: 'absolute',
                top: element.coords[0],
                left: element.coords[1],
                zIndex: '100',
              }}
            >
              {element[`${prefix}Damages`].length > 1
                ? get(damageIcons, 'Wiele uszkodzeń')
                : get(damageIcons, element.mainDamage[`${prefix}Damage`])}
            </Box>
          ),
      )}
    </Box>
  )
}

DamagesMesh.propTypes = {
  conditions: PropTypes.array,
  damageIcons: PropTypes.object,
  mesh: PropTypes.string,
  prefix: PropTypes.string,
  width: PropTypes.number,
}
DamagesMesh.defaultProps = {
  conditions: [],
  damageIcons: {},
  mesh: null,
  prefix: 'body',
  width: 0,
}

export default DamagesMesh
